module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "title is-3"
  }, [_vm._v("Pending members")]), _vm._v(" "), (!_vm.loading) ? _c('ul', _vm._l((_vm.pendingMembers), function(user) {
    return _c('li', {
      staticClass: "d-flex align-items-center justify-content-between flex-wrap"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-center mb-1"
    }, [_c('img', {
      staticClass: "mr-2 br-1",
      attrs: {
        "src": user.avatar_url + '&size=48'
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "mr-2",
      attrs: {
        "title": user.email
      }
    }, [_vm._v(_vm._s(user.name || user.email))])]), _vm._v(" "), _c('div', {
      staticClass: "d-flex justify-content-end grow-1"
    }, [_c('button', {
      staticClass: "button is-danger ml-2",
      on: {
        "click": function($event) {
          _vm.deny(user)
        }
      }
    }, [_vm._v("Deny")]), _vm._v(" "), _c('button', {
      staticClass: "button is-success ml-2",
      on: {
        "click": function($event) {
          _vm.approve(user)
        }
      }
    }, [_vm._v("Approve")])])])
  })) : _vm._e(), _vm._v(" "), (_vm.pendingMembers.length === 0 && !_vm.loading) ? _c('p', [_vm._v("No pending members!")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('Loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-610afae0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GroupModeratorPane.vue
// module id = 1047
// module chunks = 0